// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".composer-imposition-zoom-in-preview .sheet-out-of-parent .sheet-out-of{font-size:14px;font-weight:normal}.composer-imposition-zoom-in-preview{overflow:hidden}.composer-imposition-zoom-in-preview .with-without-artwork-switch{margin-right:16px}.composer-imposition-zoom-in-preview .navbar{width:100%}.composer-imposition-zoom-in-preview .sheet-out-of-parent{margin-bottom:10px}.composer-imposition-zoom-in-preview .sheet-out-of-parent .sheet-out-of{font-size:14px !important}\n", ""]);
// Exports
module.exports = exports;
